(function(){
  var onScroll=function(){var y=window.scrollY||document.documentElement.scrollTop||0;if(y>40){document.body.setAttribute('data-scrolled','')}else{document.body.removeAttribute('data-scrolled')}};
  window.addEventListener('scroll',onScroll,{passive:true});onScroll();
  document.addEventListener('click',function(e){
    var b=e.target.closest('[data-bp="burger"]');
    if(b){e.preventDefault();document.body.toggleAttribute('data-menu-open');return}
    if(e.target.closest('[data-bp="menulink"]')){document.body.removeAttribute('data-menu-open')}
    var p=e.target.closest('[data-bp="prev"]'),n=e.target.closest('[data-bp="next"]');
    if(p||n){var rail=document.querySelector('[data-bp="rail"]');if(rail){rail.scrollBy({left:(p?-1:1)*Math.round(rail.clientWidth*0.6),behavior:'smooth'})}}
  });
})();
/* Choix de langue au premier passage */
(function(){
  var KEY='bp-locale-chosen';
  var modal=document.getElementById('bp-lang-modal');
  if(!modal) return;
  var ask=/[?&]lang=ask/.test(location.search);
  if(ask){ try{ localStorage.removeItem(KEY); }catch(e){} }
  else { try{ if(localStorage.getItem(KEY)) return; }catch(e){ return; } }
  modal.hidden=false;
  document.body.style.overflow='hidden';
  modal.querySelectorAll('[data-bp="langpick"]').forEach(function(b){
    b.addEventListener('click',function(){
      try{ localStorage.setItem(KEY,'1'); }catch(e){}
      document.body.style.overflow='';
      modal.style.display='none';
    });
  });
  // filet de sécurité : si la soumission échoue, la fenêtre ne reste pas bloquée
  modal.addEventListener('submit',function(){
    setTimeout(function(){ document.body.style.overflow=''; modal.style.display='none'; },1200);
  });
})();
/* Le sélecteur d'en-tête vaut aussi choix explicite */
(function(){
  document.querySelectorAll('.bp-locale-form button').forEach(function(b){
    b.addEventListener('click',function(){ try{ localStorage.setItem('bp-locale-chosen','1'); }catch(e){} });
  });
})();
